import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BankruptcyRiskScoreHelpInfoComponent, RiskLevelIconComponent } from '@nk/company-block';
import { RiskLevelTagComponent } from './risk-level-tag/risk-level-tag.component';

@NgModule({
  declarations: [RiskLevelTagComponent],
  imports: [CommonModule, RiskLevelIconComponent, BankruptcyRiskScoreHelpInfoComponent],
  exports: [BankruptcyRiskScoreHelpInfoComponent, RiskLevelIconComponent, RiskLevelTagComponent],
})
export class RiskLevelModule {}
